import { useI18n } from 'vue-i18n';

export function useLocale() {
  const { locale } = useI18n();

  function getLocale(): 'fr' | 'en' {
    const v = locale?.value;
    if (!v) return 'en';
    return v.toString().startsWith('fr') ? 'fr' : 'en';
  }

  return { getLocale };
}
